export default "__VITE_ASSET__84aac335__"